import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  console.log(
    "ProtectedRoute: isAuthenticated=",
    isAuthenticated,
    "isLoading=",
    isLoading,
    "user=",
    user,
  );

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    console.log("ProtectedRoute: Redirecting to login");
    return <Navigate to="/" replace />;
  }

  // If authenticated but user is missing, show spinner (should be rare)
  if (!user) {
    return <div>Loading...</div>;
  }

  return children;
}
